<template>
  <div class="landing-body">
    <nav class="navbar w-nav">
      <div class="header-container">
        <div class="w-nav-brand">
          <div class="brand-logo header">
            <Cad4MillIcon />
          </div>
        </div>
        <div class="header-btns">
          <router-link :to="{name: 'login'}" class="btn-secondary w-button">Вход в сервис</router-link>
          <router-link :to="{name: 'register'}" class="btn-primary w-button">Регистрация</router-link>
        </div>
      </div>
      <div class="w-nav-overlay" />
    </nav>
    <div class="head-section">
      <div class="fill-section">
        <div class="w-container">
          <div class="row-heading w-row">
            <div class="column-main w-hidden-small w-hidden-tiny w-col w-col-6">
              <img
                src="/landing/images/1.png"
                width="441"
                srcset="/landing/images/1-p-500.png 500w, /landing/images/1-p-800.png 800w, /landing/images/1.png 1200w"
                sizes="(max-width: 767px) 100vw, (max-width: 991px) 46vw, 441px"
                alt=""
                class="scan-img">
            </div>
            <div class="head-discription-col w-col w-col-6">
              <div class="brand-wrap">
                <div class="brand-logo">
                  <Cad4MillIcon />
                </div>
              </div>
              <h1 class="h1">Дизайн стоматологических конструкций</h1>
              <div class="heading-discriptpion">Закажи у одного из моделировщиков, зарегистрированных на площадке и получи STL-файл за один день</div>
              <div @click="scroll" class="primary-btn w-button w--current">Заказать</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shadow-section" />
    <div class="_2nd-section">
      <div class="w-container">
        <div class="columns-flex w-row">
          <div class="col-padding w-col w-col-6">
            <h2 class="h2">Несколько причин почему это выгодно</h2>
            <h3 class="h3">• Это дешевле чем держать моделировщика в штате</h3>
            <h3 class="h3">• Быстро получить дизайн</h3>
            <h3 class="h3">• Легко делать заказ через электронный заказ-наряд</h3>
            <h3 class="h3">• Файлы и материалы всегда под рукой</h3>
          </div>
          <div class="col-animation _1 w-col w-col-6">
            <div id="reasons" class="_3d-warpper">
              <img
                src="/landing/images/scan-2-2.png"
                width="356"
                alt=""
                class="layer-0">
              <img
                src="/landing/images/scan-2-1.png"
                width="356"
                alt=""
                class="layer-1">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-land">
      <div class="w-container">
        <div class="w-row">
          <div class="w-col w-col-5">
            <div id="steps" class="_3d-warpper right">
              <img
                src="/landing/images/scan-1-1.png"
                width="294"
                alt=""
                class="layer-00">
              <img
                src="/landing/images/scan-1-2.png"
                width="294"
                alt=""
                class="layer-01">
            </div>
          </div>
          <div class="col-padding w-col w-col-7">
            <h2 class="h2">Всего три шага для получения дизайна</h2>
            <div class="feature-item">
              <div class="feature-icon">
                <DocPlusIcon />
              </div>
              <div class="feture-content">
                <h3 class="h3 feature">Оформи заказ-наряд в электронном виде</h3>
                <p class="p p-feature">Укажи тип изделия, материал из которого оно будетиз готовлено, выбери формулу зубов и прикрепи файлы сканов челюсти</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <ToothSearchIcon />
              </div>
              <div class="feture-content">
                <h3 class="h3 feature">Выбери моделировщика</h3>
                <p class="p p-feature">Выбери моделировщика и оплати его работу через систему</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <ToothAcceptIcon />
              </div>
              <div class="feture-content">
                <h3 class="h3 feature">Скачай результат</h3>
                <p class="p p-feature">Скачай дизайн стоматологической конструкции, которую заказал</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot />

    <div class="wrapper-section footer-sec">
      <div class="lite-fill">
        <div class="footer w-container">
          <div class="brand-logo">
            <Cad4MillIcon />
          </div>
          <div class="mail">
            <a href="mailto:info@cad4mill.com" target="_blank" class="mail">info@cad4mill.com</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cad4MillIcon from '@/icons/landing/cad4mill.svg';
  import DocPlusIcon from '@/icons/landing/doc-plus.svg';
  import ToothAcceptIcon from '@/icons/landing/tooth-accept.svg';
  import ToothSearchIcon from '@/icons/landing/tooth-search.svg';

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('transformed');
    });
  }, {threshold: 0.5});

  export default {
    name: 'LandingLayout',
    components: {
      Cad4MillIcon,
      DocPlusIcon,
      ToothAcceptIcon,
      ToothSearchIcon,
    },
    mounted() {
      setTimeout(() => {
        observer.observe(document.getElementById('reasons'));
        observer.observe(document.getElementById('steps'));
      }, 500);
    },
    methods: {
      scroll () {
        window.scrollTo({
          top: document.getElementById('create-new-order').offsetTop,
          left: 0,
          behavior: 'smooth',
        });
      },
    },
  };
</script>

<style lang="scss">
  #reasons.transformed {
    transform-style: preserve-3d;
    transition: transform 1800ms ease 0s;
    transform: rotateX(54deg) rotateY(0deg) rotateZ(-45deg);
    .layer-0 {
      transform-style: preserve-3d;
      transition: transform 200ms ease 0s;
      transform: translateX(0px) translateY(0px) translateZ(-80px);
    }
    .layer-1 {
      transform-style: preserve-3d;
      transition: transform 200ms ease 0s;
      transform: translateX(0px) translateY(0px) translateZ(80px);
    }
  }

  #steps.transformed {
    transform-style: preserve-3d;
    transition: transform 1800ms ease 0s;
    transform: rotateX(-38deg) rotateY(-43deg) rotateZ(0deg);
    .layer-00 {
      transform-style: preserve-3d;
      transition: transform 200ms ease 0s;
      transform: translateX(0px) translateY(0px) translateZ(-80px);
    }
    .layer-01 {
      transform-style: preserve-3d;
      transition: transform 200ms ease 0s;
      transform: translateX(0px) translateY(0px) translateZ(80px);
    }
  }

  .landing-body {
    #create-new-order {
      form {
        margin-top: 0;
      }
      .title h1 {
        margin-top: 0;
      }
    }

    #patient-name {
      height: auto;
      margin-bottom: 0;
      padding: 12px 16px;
      border: 0 none #000;
      background-color: #fff;
      font-size: 14px;
    }

    .formcell.checkbox {
      margin-top: 15px;
      span.label {
        margin-top: 5px;
      }
      label {
        display: flex !important;
        position: relative;
      }
    }

    .btn-wrap {
      float: unset;
    }
  }
</style>
